import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import beforeAfterService from '../services/BeforeAfterService';
import { BeforeAfterActionTypes, beforeAfterActions } from '../store/slices/beforeAfterSlice';

// Worker saga
export function* fetchBeforeAfterSection(action) {
    try {




        const response = yield call(
            beforeAfterService.getBeforeAfterPageData,
            action.payload
        );

        const responseData = get(response, 'data');
        yield put(
            beforeAfterActions.setBeforeAfterSection({
                data: responseData,
            })
        );
    } catch (err) {
        const errorMessage = err?.response?.data?.message || err.message;
        console.error('BeforeAfter fetch failed:', errorMessage);
    }
}

// Watcher saga
export default function* BeforeAfterSaga() {
    yield takeLatest(BeforeAfterActionTypes.FETCH_BEFORE_AFTER, fetchBeforeAfterSection);
}
